import Utils from '../../_functions/utils';

function AccessibilityService($rootScope, $translate, nga11yAnnounce) {
    'ngInject';

    const accessibility = this;

    accessibility.initialise = () => {
        // Exposes read only properties to the view.
        $rootScope.accessibility = Utils.readonlySubsetView({}, accessibility, 'announcePolite', 'announceAssertive');
    };

    /**
     * Announces given message in a polite way - using aria live region with a polite option.
     *
     * @param message Translation key used to obtain message to be announced.
     * @param parameters Translation auxiliary parameters.
     */
    accessibility.announcePolite = (message, parameters) => {
        $translate(message, parameters).then(translation => nga11yAnnounce.politeAnnounce(translation));
    };

    /**
     * Announces given message in an assertive way - using aria live region with an assertive option.
     *
     * @param message Translation key used to obtain message to be announced.
     * @param parameters Translation auxiliary parameters.
     */
    accessibility.announceAssertive = (message, parameters) => {
        $translate(message, parameters).then(translation => nga11yAnnounce.assertiveAnnounce(translation));
    };
}

/**
 * Accessibility service exposes some functions useful for making interface more accessible for disable users.
 * Some of its methods are exposed to $root scope as they are meant to be used inside HTML templates.
 */
angular
    .module('BB')
    .service('accessibility', AccessibilityService);


// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/core/_services/utility/accessibility.service.js